import { render, staticRenderFns } from "./grade_minmax.vue?vue&type=template&id=1897cb9d"
import script from "./grade_minmax.vue?vue&type=script&lang=js"
export * from "./grade_minmax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports